const PdfButton = ({ onClick, children }) => {
  return (
    <button
      onClick={onClick}
      className="inline-flex items-center gap-1 mx-1 px-1.5 py-0.5 bg-blue-50 text-blue-600 rounded text-xs font-semibold hover:bg-blue-100 transition-colors align-baseline cursor-pointer border border-blue-100"
    >
      📄 {children}
    </button>
  );
};

export default PdfButton;
